import React, { useState } from "react";
import {
  useGAuthEnableMutation,
  useGAuthUserDataQuery,
} from "../../redux/googleAuthApi";
import { toast, ToastContainer } from "react-toastify";
import { FiCopy } from "react-icons/fi";

function GoogleAuth() {
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [btnDisable, setDisable] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const {
    data: userData,
    refetch,
    isLoading: gettingData,
  } = useGAuthUserDataQuery();

  const [gAuthEnable, { isLoading: changing }] = useGAuthEnableMutation();

  // 🔐 Restrict input to 6 digits
  const handleValidation = (e) => {
    if (
      e.key !== "Backspace" &&
      (e.key < "0" || e.key > "9" || code.length >= 6)
    ) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.length <= 6) {
      setCode(val);
      setCodeError("");
    }
  };

  const verifyCode = async () => {
    if (!code.trim()) {
      setCodeError("Code is required");
      return;
    }

    if (!/^\d{6}$/.test(code.trim())) {
      setCodeError("Code must be exactly 6 digits");
      return;
    }

    setDisableSubmit(true);
    setTimeout(() => setDisableSubmit(false), 3000);

    try {
      const payload = { code: code.trim() };
      const res = await gAuthEnable(payload).unwrap();
      toast.dismiss();
      if (res?.status) {
        toast.success(res?.message || "2FA status changed");
        setCode("");
        refetch(); // 🔁 Refresh QR/status
      } else {
        setCodeError(res?.message || "Invalid code");
        toast.dismiss();
        toast.error(res?.message || "Invalid code");
      }
    } catch (error) {
      const msg =
        error?.data?.message || error?.message || "Something went wrong";
      toast.error(msg);
    }
  };

  const copyToClipboard = async (text) => {
    if (!text) {
      return false;
    }

    if (window.isSecureContext && navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "-1000px";
    textarea.style.left = "-1000px";
    document.body.appendChild(textarea);
    textarea.select();
    const didCopy = document.execCommand("copy");
    document.body.removeChild(textarea);
    return didCopy;
  };

  const handleCopy = async () => {
    setDisable(true);
    setTimeout(() => setDisable(false), 3000);

    try {
      const didCopy = await copyToClipboard(userData?.google_hash || "");
      toast.dismiss();
      if (didCopy) {
        toast.success("Key Copied!");
      } else {
        toast.error("Unable to copy");
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Unable to copy");
    }
  };

  return (
    <div className="auth-left col-lg-5 mb-3">
      <div className="white_box h_100 mb-0">
        <h5>Google Authentication</h5>
        <div className="google-auth">
          <div className="auth-left mb-3">
            <div
              className={
                userData?.isBlur ? "qr-outer kyc_bg qr_load" : "qr-outer kyc_bg"
              }
            >
              <img
                className="img-fluid"
                src={userData?.qrCodeUrl}
                alt="qrCode"
              />
            </div>
          </div>

          <div className="auth-right">
            <h5 className="kyc_h5 d-flex align-items-center ">
              Key: <span>{userData?.google_hash}</span>
              {userData?.google_hash && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                  onClick={handleCopy}
                  disabled={btnDisable}
                >
                  <FiCopy />
                </button>
              )}
            </h5>

            <h5>
              Status: {userData?.two_fa_status === 0 ? "Disabled" : "Enabled"}
            </h5>

            <label className="fw-500">Authentication Code</label>
            <div className="row">
              <div className="form-group col-lg-7 col-12">
                <input
                  type="number"
                  className="form-control"
                  name="vcode"
                  placeholder="Enter Code"
                  onKeyDown={handleValidation}
                  value={code}
                  onChange={handleChange}
                />
                <div style={{ color: codeError ? "red" : "green" }}>
                  {codeError || userData?.message}
                </div>
              </div>

              <div className="form-group col-lg-5 col-12">
                <button
                  onClick={verifyCode}
                  className="btn btn_man w100px"
                  disabled={changing || disableSubmit}
                >
                  {changing
                    ? "Processing..."
                    : userData?.two_fa_status !== 0
                    ? "Disable"
                    : "Enable"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoogleAuth;
